import React, { useEffect, useState } from "react";
import { ObtenerInformacionHistorialModPHE, ObtenerUnidadesHistorialModPHE } from "./FunctionsHistorialModPHE";
import { HistorialModificacionPHE, HistorialUnidadesModPHE } from "../Asignacion Presupuesto/TypesPresupuestoGPEHE";
import { showAlert } from "components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras";
import { Pagination, PaginationItem, PaginationLink, Col, Input, Row, Label } from "reactstrap";
import TablaHistorialModificacion from "./TablaHistorialModificacion";
import YearDatePicker from "components/Varios/DatePicker/YearDatePicker";
import { FormGroup } from "react-bootstrap";
import Cargando from "components/Varios/Cargando";


export default function HistorialModificacionPresupuesto() {

    const TITULO_PANTALLA = "HISTORIAL DE LAS MODIFICACIONES DEL PRESUPUESTO DE LAS UNIDADES";

    const [unidades, setunidades] = useState<HistorialUnidadesModPHE[]>([]);
    const [idUnidades, setidUnidades] = useState<number | null>(null);
    const [anioSelec, setanioSelec] = useState<number | null>(null);
    const [loading, setloading] = useState<boolean>(false);

    const fechaHoy = new Date();

    useEffect(() => {
        setanioSelec(fechaHoy.getFullYear())
        ObtenerHistorialUnidadesModPHE(fechaHoy.getFullYear());
    }, [])

    async function ObtenerHistorialUnidadesModPHE(anio: number) {
        setloading(true)
        const unidadesHisto = await ObtenerUnidadesHistorialModPHE(anio);
        if (unidadesHisto.status === 200 && unidadesHisto.dataResponse) {
            setunidades(unidadesHisto.dataResponse);
        }
        else {
            showAlert(unidadesHisto.errorMessage ?? "Error al obtener la informacion", false);
        }
        setloading(false)
    }

    async function onChangeYear(value: any) {
        const fechaIndicada = new Date(value);
        const anioSeleccionado = fechaIndicada.getFullYear();
        setanioSelec(anioSeleccionado);
    }

    return (
        <div className='content'>
            <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>
            {loading && <Cargando />}
            {!loading && (
                <React.Fragment>
                    <Row className=" row-no-margin justify-content-start ">
                        <Col xl={4} className="alignContentend">
                            <FormGroup className="d-flex flex-column">
                                <Label>
                                    Unidades:
                                </Label>
                                <select
                                    className="largeContainerOptionStyle"
                                    style={{
                                        display: 'block',
                                    }}
                                    value={idUnidades ?? ""}
                                    onChange={(e) => setidUnidades(Number(e.target.value) || null)}
                                >
                                    <option value="">Seleccione...</option>
                                    {unidades.map((u, i) => (
                                        <option key={i} value={u.idunidad}>
                                            {u.nombreunidad}
                                        </option>
                                    ))}
                                </select>
                            </FormGroup>
                        </Col>
                        <Col xl={2} className="alignContentend">
                            <FormGroup className="d-flex flex-column">
                                <Label className="mb-2">
                                    Año:
                                </Label>
                                <YearDatePicker
                                    value={anioSelec}
                                    onChange={(value) => onChangeYear(value)}
                                    minDate={"2025-01-01"}
                                    maxDate={new Date(fechaHoy.getFullYear(), 0, 1, 0, 0, 0, 0).toISOString()}
                                    blueStyle={true}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <br />
                    <TablaHistorialModificacion
                        idEstructura={idUnidades}
                        anio={anioSelec}
                    />
                </React.Fragment>
            )}
        </div>
    )
}